export const SHARED_EXPORT_TEXTS = {
  // Target section
  TARGET_TITLE: 'Target',
  TARGET_EMAIL: 'Email',
  TARGET_S3: 'S3',
  TARGET_SFTP: 'SFTP',
  TARGET_GCS: 'GCS',
  SELECT_SYSTEM_USER: 'Select System User',

  // S3 fields
  S3_PATH: 'Path',
  S3_BUCKET_NAME: 'Bucket Name',
  S3_ACCESS_KEY_ID: 'Access key id',
  S3_ACCESS_KEY_SECRET: 'Access key secret',

  // GCS fields
  GCS_PATH: 'Path',
  GCS_BUCKET_NAME: 'Bucket Name',
  GCS_SECRET_JSON: 'Secret json',

  // SFTP fields
  SFTP_HOST: 'Host',
  SFTP_PORT: 'Port',
  SFTP_PATH: 'Path',
  SFTP_USER: 'User',
  SFTP_PASSWORD: 'Password',

  // Schedule details
  SCHEDULE_DETAILS_TITLE: 'Schedule Details',
  DAILY_REPEAT_ON: 'Daily Repeat On',
  HOUR_LABEL: 'Hour',
  END_DATE_CHECKBOX: 'End Date',
  END_DATE_LABEL: 'End Date',
  RECURRENCE_LABEL: 'Recurrence',
  RECURRENCE_DAILY: 'Daily',
  RECURRENCE_MONTHLY: 'Monthly',
  DAY_OF_MONTH_LABEL: 'Day of Month',

  // Validation messages
  VALIDATION_REQUIRED: 'Required',
  VALIDATION_NO_WHITESPACE: 'Cannot start or end with spaces',
  VALIDATION_INVALID_SECRET_JSON: 'Invalid secret json format',

  // Report template select
  REPORT_TEMPLATE_LABEL: 'Report Template',
  REPORT_TEMPLATE_NO_TEMPLATES: 'No active templates available',
} as const;
